export const getWhereConditionForCategoryId = (categoryId: string) => {
	return `masterData(current(categories(id=\\"${categoryId}\\")))`
}
